module.exports = __webpack_public_path__ + "static/media/image-008n.ba21ae35.jpeg";